import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticPropsContext } from 'next'
import { StoreHubStoryContent } from './types/store-hub'

export const getStaticPropsfn = async ({
  preview = false,
}: GetStaticPropsContext) => {
  try {
    const story = await getStoryBySlug<StoreHubStoryContent>(`store`, {
      version: preview ? 'draft' : 'published',
    })

    if (!story) {
      throw new Error('Store information story not found')
    }
    const heroProps = {
      ...story.content.hero[0],
    }

    return {
      props: {
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          showBorderRadius: true,
          heroProps,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch (error) {
    if (typeof error === 'string' || error instanceof Error) {
      console.log(error)
    }

    return {
      notFound: true,
    }
  }
}

export type StoreHubProps = Extract<
  Awaited<ReturnType<typeof getStaticPropsfn>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { props: any }
>['props']

export const getStaticProps = traceFunction(
  'store-page.getStaticProps',
  getStaticPropsfn,
)
